module.exports = __webpack_public_path__ + "static/media/dog-gone-square-logo-dark-bg.ffd17fba.png";